if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.sectionId = this.dataset.sectionId;
        this.cartData = document.querySelector('product-info').cartData();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        // Create request data object for Cart API
        let requestData = {
          items: [],
        };

        // Add sections for cart rendering if cart exists
        if (this.cart) {
          requestData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestData.sections.push('main-product');
          requestData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        // Extract form data
        const formData = new FormData(this.form);
        const currentQuantity = Number(formData.get('quantity'));
        const variantId = parseInt(formData.get('id'));

        // Collect all properties from form data
        const allProperties = {};
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propName = key.slice(11, -1); // Extract property name from "properties[name]"
            allProperties[propName] = value;
          }
        }

        const giftKitType = document.querySelector('select[name="gift-wrapping"]');
        // Add functionality to fetch cart data from this.cart.js to check if any item already has a gift before adding new item
        const cartData = await fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((data) => {
            return data;
          });
        const currentCartHasGift = cartData.items.some((item) => item.properties._giftKitFee && item.properties._giftKitFee != '');
        if (currentCartHasGift) {
          const giftKitContainer = document.querySelector(`#Gift-kit-${this.sectionId}`);
          if (giftKitContainer) {
            giftKitContainer.innerHTML = '';
          }
        }

        if (giftKitType && giftKitType.value != '' && !currentCartHasGift) {
          const nameGiftKit = giftKitType.value.split('//')[0];
          const priceGiftKit = giftKitType.value.split('//')[1];

          if (currentQuantity > 1) {
            // Split item into 2 items: 1 item with quantity = 1 (with gift), 1 item with quantity = currentQuantity - 1 (without gift)

            // Item with quantity = 1 including gift kit + all other properties
            const itemWithGift = {
              id: variantId,
              quantity: 1,
              properties: {
                ...allProperties, // Apply all existing properties
                [nameGiftKit]: priceGiftKit,
                _giftKitFee: priceGiftKit,
              },
            };
            requestData.items.push(itemWithGift);

            // Item with quantity = currentQuantity - 1 without gift kit + all other properties
            if (currentQuantity - 1 > 0) {
              const itemWithoutGift = {
                id: variantId,
                quantity: currentQuantity - 1,
                properties: {
                  ...allProperties, // Apply all existing properties
                },
              };
              requestData.items.push(itemWithoutGift);
            }
          } else {
            // Quantity = 1, add gift kit to properties
            const itemWithGift = {
              id: variantId,
              quantity: currentQuantity,
              properties: {
                ...allProperties,
                [nameGiftKit]: priceGiftKit,
                _giftKitFee: priceGiftKit,
              },
            };
            requestData.items.push(itemWithGift);
          }
        } else {
          // No gift kit, add normal item
          const item = {
            id: variantId,
            quantity: currentQuantity,
            properties: allProperties,
          };
          requestData.items.push(item);
        }

        // Update config to send JSON data
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(requestData);

        if (parseInt(formData.get('quantity')) > parseInt(document.querySelector('product-info').dataset.selectedVariantInventory)) {
          this.handleErrorMessage(`在庫残り${document.querySelector('product-info').dataset.selectedVariantInventory}個`);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            const newMainProduct = new DOMParser().parseFromString(response.sections['main-product'], 'text/html');
            this.cartData = JSON.parse(newMainProduct.querySelector('script#CartData').textContent);
            const haveAtLeastOneGiftKit = this.cartData.items.some((item) => item.properties._giftKitFee && item.properties._giftKitFee != '');
            if (haveAtLeastOneGiftKit) {
              if(document.querySelector(`#Gift-kit-${this.sectionId}`)) {
                document.querySelector(`#Gift-kit-${this.sectionId}`).innerHTML = '';
              }
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
